import React, { useEffect, useRef, useState } from "react";
import GreenPanelLogo from "../../images/greenpanel-logo.png";
import USerIcon from "../../images/svg/userIcon.svg";
import "remixicon/fonts/remixicon.css";
import ScanIcon from "../../images/svg/scanIcon.svg";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { useSelector, useDispatch } from "react-redux";
import "./layout.css";
import MaingateModal from "../../Modal/MaingateModal";
import BoombarrierModal from "../../Modal/BoombarrierModal";
import { Mail, UserRound, LogOut, CloudCog } from "lucide-react";
import { logout } from "../../Redux/CommonSlice/authSlice";
import { useNavigate, useLocation } from "react-router-dom";
import { IP_Address } from "../../Api";
import { setActiveTabLabel } from "../../Redux/CommonSlice/allDataSlice";

const Header = ({ showBoombarrierModal, setShowBoombarrierModal }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const imgRef = useRef(null);
  const [showMaigateModal, setShowMainGateModal] = useState(false);
  const [isLiveStreamStart, setIsLiveStreamStart] = useState(false);
  const [socket, setSocket] = useState(null);
  const [socketOpen, setSocketOpen] = useState(false);
  const [noCameraFound, setNoCameraFound] = useState(false)
  const activeTabLabel = useSelector((state) => state.data.activeTabLabel);
  const auth = useSelector((state) => state.auth);
  const { user, camera_details } = auth;
  const [cameraFrame, setCameraFrame] = useState(null);

  const { permissions } = user?.user_permissions || {}
  useEffect(() => {
    let ws;

    const connectWebSocket = () => {
      ws = new WebSocket(`ws://${IP_Address}/ws/streams/`);

      ws.binaryType = "arraybuffer";

      ws.onopen = () => {
        console.log("WebSocket connection opened");
        setSocket(ws);
        ws.send(
          JSON.stringify({
            token: `${localStorage.getItem("accessToken")}`,
            camera_type: showMaigateModal ? "main_gate" : "boom_barrier",
          })
        );
      };

      ws.onmessage = (e) => {

        setNoCameraFound(false)
        if (typeof e.data === "string") {
          const message = JSON.parse(e.data);

          if (message["loading"]) {
            setNoCameraFound(false)
            console.log("loading...");
          } else if (!message['camera_status']) {
            console.log("No Camera Found")
            setNoCameraFound(true)
          }
          else {
            setNoCameraFound(false)
            console.log("done...");
          }
        }

        if (e.data instanceof ArrayBuffer) {
          setNoCameraFound(false)
          const frameData = e.data;
          setCameraFrame(frameData);
          const img = document.getElementById("liveViewId");
          // if (img) {
          //   img.src = URL.createObjectURL(
          //     new Blob([frameData], { type: "image/jpeg" })
          //   );
          setIsLiveStreamStart(true);
          // }
        } else {
          console.warn("Unknown message type received:", e.data);
        }
      };

      ws.onclose = (e) => {
        console.error("Socket closed unexpectedly:", e);
        setIsLiveStreamStart(false);
        //     setTimeout(() => {

        // if (socketOpen &&  showBoombarrierModal) {
        //         console.log("Attempting to reconnect...");
        //         // connectWebSocket();
        //       }
        //     }, 1000);
      };

      ws.onerror = (e) => {
        console.error("Socket encountered error:", e);
        ws.close();
      };
    };
    if (socketOpen) {
      connectWebSocket();
    }

    return () => {
      if (ws) {
        ws.close();
      }
    };
  }, [socketOpen]);

  useEffect(() => {
    setSocketOpen(showBoombarrierModal || showMaigateModal);
  }, [showBoombarrierModal, showMaigateModal]);

  useEffect(() => {
    if (!activeTabLabel) {
      const label = {
        '/': 'Vehicle Entries',
        '/vehicle-data': 'Vehicle Data',
        '/cameras': 'Camera Setting',
        '/users': 'Users',
        '/settings': 'Settings'
      }[location.pathname];
      
      label && dispatch(setActiveTabLabel(label));
    }
  }, [location.pathname, activeTabLabel, dispatch]);

  return (
    <div>
      <div className="w-[100%] h-[73px] px-[17px] py-[13px] bg-white justify-between items-center inline-flex">
        <div className="justify-start items-center gap-[18px] flex">
          <div className="h-9 justify-start items-center gap-[3px] flex">
            <img className="h-[37px]" src={GreenPanelLogo} />
          </div>
          <div className="border-[2px] border-lime-500 h-[30.5px] rounded-md"></div>
          <div className="text-black text-xl font-semibold">
            {activeTabLabel}
          </div>
        </div>
        <div className="w-auto self-stretch justify-end items-center gap-[15px] flex">
          <div className="flex items-center justify-center">
            {/* {
                 permissions?.main_gate_camera_button && <button
                 className="w-[165px] h-[45px] self-stretch px-3 py-3 bg-green-500 rounded-[3px] items-center gap-2 flex text-white text-base font-medium"
                 onClick={() => setShowMainGateModal(true)}
               >
                 <span className="mr-1">
                   <img src={ScanIcon} alt="Scan Icon" />
                 </span>
                 Main Gate
               </button>
            } */}


            <MaingateModal
              show={showMaigateModal}
              onHide={() => setShowMainGateModal(false)}
              socket={socket}
              imgRef={imgRef}
              setSocketOpen={setSocketOpen}
              socketOpen={socketOpen}
              isLiveStreamStart={isLiveStreamStart}
              cameraFrame={cameraFrame}
              noCameraFound={noCameraFound}
            />
          </div>
          <div className="flex items-center justify-center">
            {
              permissions?.boom_barrier_camera_button && <button
                className="w-[165px] h-[45px] px-3 py-3 bg-green-500 rounded-[3px] flex items-center gap-2 text-white text-base font-medium"
                onClick={() => {
                  setShowBoombarrierModal(true);
                  setSocketOpen(true);
                }}
              >
                <span className="mr-1">
                  <img src={ScanIcon} alt="Scan Icon" />
                </span>
                Boom Barrier
              </button>
            }


            <BoombarrierModal
              show={showBoombarrierModal}
              onHide={() => setShowBoombarrierModal(false)}
              socket={socket}
              imgRef={imgRef}
              setSocketOpen={setSocketOpen}
              socketOpen={socketOpen}
              isLiveStreamStart={isLiveStreamStart}
              cameraFrame={cameraFrame}
              noCameraFound={noCameraFound}
            />
          </div>
          <div className="w-[200px] self-stretch p-2.5 bg-[#6CD04E1A] rounded-[5px] justify-between items-center flex">
            <div className="w-[200px] flex user-dropdown items-center justify-between relative ">
              <img src={USerIcon} />
              <span 
                className="max-w-[120px] overflow-hidden whitespace-nowrap overflow-ellipsis cursor-default select-none text-base font-medium pl-1"
                title={user?.username}
              >
                {user?.username}
              </span>
              <DropdownButton id="dropdown-basic-button" title="">
                <Dropdown.Item href="#/action-1">
                  <div className="flex items-center gap-2 text-[14px] text-[var(--lightText)]">
                    <Mail size={16} />{" "}
                    <p className="p-0 m-0">{user?.username}</p>
                  </div>
                </Dropdown.Item>
                <Dropdown.Item href="#/action-2">
                  <div className="flex items-center gap-2 text-[14px] text-[var(--lightText)]">
                    <UserRound size={16} />{" "}
                    <p className="p-0 m-0">{user?.role}</p>
                  </div>
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => { dispatch(logout(navigate)) }}
                >
                  <div
                    className="flex items-center justify-between text-[15px] font-semibold text-[#000]"
                    onClick={() => {
                      dispatch(logout(navigate));
                    }}
                  >
                    Logout <LogOut />
                  </div>
                </Dropdown.Item>
              </DropdownButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
